export default {"src":"/_next/static/media/Header.90051906.svg","height":21,"width":237,"blurWidth":0,"blurHeight":0};